import React from 'react'
import Pricing from '../components/sections/pricing'
import ServiceGrid from '../components/sections/serviceGrid'

const Service = () => {
    return (
        <>
            <ServiceGrid />
        </>
    )
}

export default Service